<modal
  [id]="modalId"
  [header]="'Invite team members'"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="true"
  [showHeaderDivider]="true"
  [heightClass]="'tw-h-[600px]'"
  [enableBackdropClose]="true"
  [escapeToClose]="false"
  (onCloseModal)="onModalClosed()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-h-full">
    <div class="tw-flex tw-flex-col">
      <fullname [control]="memberForm().controls['fullname']" [label]="'Full name'" [id]="'fullname-input'" [required]="true" [autofocus]="true" />
      <email-input
        [control]="memberForm().controls['email']"
        [label]="'Email'"
        [id]="'email-input'"
        [required]="true"
        [isLoading]="isValidatingEmail()"
        (onBlurValueChange)="onEmailBlur()"
      />
      <select-input
        [control]="memberForm().controls['role']"
        [label]="'Role'"
        [id]="'role-input'"
        [required]="true"
        [valueName]="'id'"
        key="name"
        [values]="roles()"
        [maxSelections]="1"
        [enableSearch]="false"
        [isCountryField]="false"
        [isSingleSelect]="true"
        [isDropdown]="false"
      />
      <p class="tw-text-sm tw-text-gray-500 tw-font-inter tw-font-normal tw-mt-1 tw-mb-4 tw-mt-[-20px] tw-px-3 tw-pb-1.5 tw-pt-1 tw-z-10">
        Need help? Check the
        <button
          type="button"
          class="tw-inline tw-text-blue-600 tw-font-medium tw-cursor-pointer tw-bg-transparent tw-border-none tw-p-0 tw-font-inherit tw-leading-inherit"
          (click)="onOpenRolesPrivilegeTable()"
        >
          Roles Privilege table</button
        >.
      </p>
      <text-area [control]="memberForm().controls['message']" [label]="'Invitation message'" [id]="'message-input'" [counter]="true" [maxCharacters]="250"></text-area>
    </div>
  </div>
  <div slot="footer" class="tw-p-6 tw-pt-0">
    <button
      type="button"
      (click)="onInviteClick()"
      [disabled]="isInviting()"
      class="tw-w-full tw-bg-blue-600 tw-text-white tw-px-5 tw-justify-center tw-py-2.5 tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-font-inter tw-text-sm tw-font-medium disabled:tw-opacity-70 disabled:tw-cursor-not-allowed"
    >
      @if (isInviting()) {
      <progress-circle [colorClasses]="'tw-border-white tw-border-r-transparent'"></progress-circle>
      } @else {
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_48223_40179)">
          <path
            d="M8.98438 1.6665C9.01447 1.66456 9.063 1.6737 9.11719 1.73096L13.1436 5.97998C13.3323 6.17925 13.4628 6.47083 13.4932 6.79736L13.5 6.93896C13.5005 7.32296 13.3624 7.67078 13.1475 7.8999L9.05273 12.269C9.00292 12.322 8.95674 12.3334 8.92773 12.3335C8.89386 12.3335 8.83815 12.3181 8.7832 12.2466H8.78223C8.65769 12.0851 8.67486 11.8157 8.80176 11.6802L12.8975 7.31201L13.2168 6.97021L12.8975 6.62842L8.87012 2.32275L8.86719 2.3208L8.8252 2.26416C8.73858 2.12118 8.73801 1.89776 8.84668 1.75537L8.8457 1.75439C8.89929 1.68486 8.953 1.66864 8.98438 1.6665ZM5.25684 2.55225C5.38858 2.47909 5.53003 2.47649 5.67578 2.5874L5.73828 2.64209L9.46582 6.2915C9.61104 6.43355 9.7177 6.67525 9.71777 6.97021C9.71777 7.26503 9.61132 7.50771 9.46582 7.65088L5.73828 11.3013C5.59234 11.444 5.44862 11.469 5.3125 11.4165L5.25488 11.3901L5.18164 11.3413C5.0148 11.2099 4.87706 10.9538 4.87695 10.6021V9.09619L4.30859 9.17432C2.92679 9.36568 1.79068 10.4442 1.21289 11.9517L1.21191 11.9526C1.11594 12.2032 0.968245 12.2581 0.891602 12.2583C0.875873 12.2583 0.854806 12.2558 0.827148 12.2495C0.69583 12.2133 0.500049 12.0248 0.5 11.6519V10.5103C0.500142 7.43151 2.33145 5.08997 4.42578 4.88232L4.87695 4.83838V3.34033C4.87695 2.93748 5.05738 2.66132 5.25293 2.5542L5.25684 2.55225Z"
            fill="white"
            stroke="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_48223_40179">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Send invitation }
    </button>
  </div>
</modal>
